import {PermissionType} from '@hconnect/apiclient'
import {useUpmPlant, useUpmPlantsContext} from '@hconnect/upm'
import {usePermission, checkPermissionsByDataScope} from '@hproduce/permissions'
import {useCallback} from 'react'

import {useGlobalContext} from './useGlobalContext'
import {useUrlParam} from './useUrlParam'

export const usePlantPermission = (...permissionTypes: PermissionType[]) => {
  const plantId = useUrlParam('plantId')
  const upmPlant = useUpmPlant({plantId, shouldRaiseError: true})

  const plantContext = {plantId, countryId: upmPlant.country}

  return usePermission({
    plantContext,
    permissionTypes
  })
}

export const useCheckPlantPermission = () => {
  const upmPlants = useUpmPlantsContext()
  const {
    state: {permissions}
  } = useGlobalContext()

  return useCallback(
    (permissionTypes: PermissionType[], plantId: string) => {
      const upmPlant = upmPlants[plantId]
      if (!upmPlant || !permissions) return false
      const plantContext = {plantId, countryId: upmPlant.country}
      return checkPermissionsByDataScope(permissions, plantContext, permissionTypes)
    },
    [permissions, upmPlants]
  )
}
